var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('csr-banner'),_c('public-nav',{on:{"change":_vm.handleOpen}}),_c('csr-content3'),_c('public-footer'),_c('public-menu',{ref:"home-menu",on:{"change":_vm.handleClose}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }